export default {
    PAGE: {
        WIPZN: {
            INDEX: '/',
        },
    },
    API: {
        WIPZN: {
            LOGIN: '/wipzn/login',
        },
    },
};
